module.exports = __webpack_public_path__ + "media/images/social/instagram2-fdedeb218f232e52c8b6028376478f32.png";